import { render, staticRenderFns } from "./taskHallItem.vue?vue&type=template&id=3aab2712&scoped=true&"
import script from "./taskHallItem.vue?vue&type=script&lang=js&"
export * from "./taskHallItem.vue?vue&type=script&lang=js&"
import style0 from "./taskHallItem.vue?vue&type=style&index=0&id=3aab2712&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aab2712",
  null
  
)

export default component.exports